module.exports = __webpack_public_path__ + "static/img/2.08a1362.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/detail/common/medication/2.png
// module id = 2rAB
// module chunks = 1